import { useEffect, useState } from 'react';
import instructorsApi from 'Api/axios/instructors-api';

/** Opción mínima para el dropdown de instructores. */
export interface InstructorOption {
  id: string;
  name: string;
}

/**
 * Carga los instructores activos del catálogo (`/api/instructors`) para
 * poblar el selector de aprobación. Solo consulta cuando `enabled` es true,
 * de modo que no pega al backend con el modal cerrado.
 */
const useInstructorOptions = (enabled: boolean) => {
  const [options, setOptions] = useState<InstructorOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;

    let active = true;
    setLoading(true);

    instructorsApi
      .readAll({ status: 'active', pageSize: 100 })
      .then(res => {
        if (!active) return;
        const list = (res.data || []).map(instructor => ({
          id: instructor.id,
          name: instructor.name,
        }));
        setOptions(list);
      })
      .catch(() => {
        if (active) setOptions([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [enabled]);

  return { options, loading };
};

export default useInstructorOptions;
